import React, { Component } from 'react';

const ExampleCallouts = () =>
  <section id="callouts">
    <h3 className="section-header">Callouts</h3>

    <div className="row medium-up-3">
      <div className="column">
        <div className="callout primary">
          <h3>Callout Primary</h3>
          <p>Callout Primary Text</p>
        </div>
      </div>
      <div className="column">
        <div className="callout secondary">
          <h3>Callout Secondary</h3>
          <p>Callout Secondary Text</p>
        </div>
      </div>
      <div className="column">
        <div className="callout success">
          <h3>Callout Success</h3>
          <p>Callout Success Text</p>
        </div>
      </div>
    </div>

    <div className="row medium-up-3">
      <div className="column">
        <div className="callout warning">
          <h3>Callout Warning</h3>
          <p>Callout Warning Text</p>
        </div>
      </div>
      <div className="column">
        <div className="callout alert">
          <h3>Callout Alert</h3>
          <p>Callout Alert Text</p>
        </div>
      </div>
    </div>

  </section>;

export { ExampleCallouts }



// WEBPACK FOOTER //
// ./styleguide/components/callouts.jsx